import { render, staticRenderFns } from "./prop.vue?vue&type=template&id=2bd22947&scoped=true&"
import script from "./prop.vue?vue&type=script&lang=js&"
export * from "./prop.vue?vue&type=script&lang=js&"
import style0 from "./prop.vue?vue&type=style&index=0&id=2bd22947&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd22947",
  null
  
)

export default component.exports